import React, { createContext, useContext } from 'react';
import type { MetricProviderId } from './types';

const Context = createContext<MetricProviderId | null>(null);
export function DeviceMetricProvider({ provider, children }: { provider: MetricProviderId | null; children: React.ReactNode }) {
  return <Context.Provider value={provider}>{children}</Context.Provider>;
}
export const useDeviceMetricProvider = () => useContext(Context);
